import { useFlags } from "launchdarkly-react-client-sdk";
import Lottie from "lottie-react";
import React from "react";

import ottoScribblesBuild from "../../assets/imgs/otto-scribbles-build.json";
export default function Maintenance() {
  const { dateAndTimeExpectedBackOnline } = useFlags();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="text-center max-w-4xl">
        <Lottie
          animationData={ottoScribblesBuild}
          className="w-[300px] mx-auto mb-6"
          loop={true}
          autoplay={true}
        />
        <h1 className="text-4xl font-bold !text-black mb-6">
          We're Making Things Better
        </h1>
        <div className="text-base font-normal text-gray-700 space-y-6">
          <div>
            Scribenote is currently undergoing scheduled maintenance
            to improve your experience.
            {dateAndTimeExpectedBackOnline && (
              <>
                {" "}
                We are expecting to be back online by{" "}
                <span className="font-bold text-indigo-600">
                  {dateAndTimeExpectedBackOnline}.
                </span>
              </>
            )}{" "}
            Until we're back online, you can{" "}
            <a
              href="https://docs.scribenote.com/en/articles/10706399-how-do-i-upload-external-audio"
              target="_blank"
              rel="noopener noreferrer"
              className="text-indigo-600 font-semibold hover:underline"
            >
              learn how to make recordings offline
            </a>
            .
          </div>
          <div>
            If you need to reach us, please email{" "}
            <a
              href="mailto:support@scribenote.com"
              className="text-indigo-600 font-semibold hover:underline"
            >
              support@scribenote.com
            </a>
            . For further updates, please check our{" "}
            <a
              href="https://status.scribenote.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-indigo-600 font-semibold hover:underline"
            >
              status page
            </a>
            .
          </div>
        </div>
      </div>
    </div>
  );
}
